document.querySelectorAll('.copyright__text').forEach(($copyright) => {
  if ($copyright.innerText.includes('©')) {
    const text = $copyright.innerHTML;
    const newText = text.replace(new RegExp('©'), '<span class="copyright__character">©</span>');
    const $text = $copyright;
    $text.innerHTML = newText;
  }
});
